// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"jamaicanLabels_pageWrapper__2lXtl"};